import { useCallback } from "react";

import { toast } from "react-toastify";

import { type ObservacaoFormData, ObservacaoFormModal } from "@components/observacao-form-modal";

import { useUpdateTarefa } from "@/hooks/minhas-tarefas/use-update-tarefa";

import { useStoreZustandMinhasTarefas } from "@/store-zustand/admin/minhas-tarefas";
import { useStoreZustandUserAuth } from "@/store-zustand/user-auth";

type IObservationModalProps = {
  idRemessa: number;
  handleToggleCreateActvityModal: () => void;
  setCurrentScreen: () => void;
};

const MyTasksObservationModal = ({
  handleToggleCreateActvityModal,
  idRemessa,
  setCurrentScreen,
}: IObservationModalProps) => {
  const { user } = useStoreZustandUserAuth();
  const { tarefa } = useStoreZustandMinhasTarefas();

  const { mutate: mutateUseUpdateTarefa, isPending } = useUpdateTarefa();

  const onSubmit = useCallback(
    (data: ObservacaoFormData) => {
      if (!user?.id) {
        toast.error("Usuário não autenticado.");
        return;
      }

      mutateUseUpdateTarefa(
        {
          id_remessa: Number(idRemessa),
          payload: {
            user_id_executor: user.id,
            observacao: data.observation,
          },
        },
        {
          onSuccess: () => {
            handleToggleCreateActvityModal();
            setCurrentScreen();
          },
          onError: () => {
            handleToggleCreateActvityModal();
          },
        }
      );
    },
    [idRemessa, user?.id, mutateUseUpdateTarefa, handleToggleCreateActvityModal, setCurrentScreen]
  );

  return (
    <ObservacaoFormModal
      title="Adicionar Observação para tarefa"
      submitLabel="Adicionar"
      initialObservacao={String(tarefa?.observacao ?? "")}
      isSubmitting={isPending}
      textareaDisabled={isPending}
      onClose={handleToggleCreateActvityModal}
      onSubmit={onSubmit}
    />
  );
};

export { MyTasksObservationModal };
